<template>
  <div>
    <b-row v-if="
    isEmpty(customer)">
      <b-col class="text-center">
        <b-alert show variant="info">
          Compila il modulo di ricerca e clicca sul tasto Dettaglio sul Cliente interessato.
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col md="3">
        <b-card id="shop-card" style="margin-bottom: 1rem" no-body>
          <template #header>
            <h5>
              <b-icon-shop/>&nbsp;Punto di Imissione
            </h5>
          </template>
          <b-card-text style="margin: 1rem" class="text-center" v-if="activeBarcode">{{ activeBarcode.shopCode }}</b-card-text>
          <b-card-text style="margin-bottom: 1rem" class="text-center" v-if="activeBarcode">{{ activeBarcode.shopName }}</b-card-text>
        </b-card>
        <b-card id="barcodes-card" style="margin-bottom: 1rem" no-body>
          <template #header>
            <h5>
              <b-icon-card-heading/>&nbsp;Elenco tessere
            </h5>
          </template>
          <b-table id="barcodes-table" hover :items="barcodes" :fields="barcodesTable" style="margin-bottom: unset">
            <template #cell(index)="data">
              <b-icon-upc/>
            </template>
            <template #cell(barcode)="data">
              <code class="text-dark">{{ data.item.barcode }}</code><br>
            </template>
            <template #cell(disabledAt)="data">
              <div v-if="data.item.isDisabled">
              <span>Disabilitata il&nbsp;<b-badge
                variant="secondary"><samp>{{ data.item.disabledAt }}</samp></b-badge></span>
                <br>
              <span v-if="data.item.disabledBy && data.item.disabledBy.trim() !== ''"> Disabilitata da <b-badge
                variant="secondary"><samp>{{ data.item.disabledBy }}</samp></b-badge></span>
              </div>
              <span v-else>
                <span>Attiva</span>
                <b-button size="sm" title="Disattiva Tessera" @click="disableBarcode(data.item.barcode)" style="margin-left: 3em"
                          :hidden=hideDisableBarcodeButton>Disattiva</b-button>
              </span>
            </template>
          </b-table>
        </b-card>
        <b-card id="consensus-card" style="margin-bottom: 1rem" no-body>
          <template #header>
            <h5>
              <b-icon-patch-check/>&nbsp;Consensi forniti dal Cliente
            </h5>
          </template>
          <b-table id="consensus-table" hover :items="selectedConsensus" :fields="consensusTable"
                   style="margin-bottom: unset">
            <template #cell(isCheck)="data">
              <b-icon-check-square-fill v-if="data.item.isCheck"/>
              <b-icon-square v-else/>
            </template>
            <template #cell(consensus)="data">
              {{ data.item.consensus }}
            </template>
          </b-table>
        </b-card>
        <b-card v-if="affiliation" id="affiliations" no-body>
          <template #header>
            <h5>
              <b-icon-bookmark/>&nbsp;Cluster
            </h5>
          </template>
          <b-list-group>
            <b-list-group-item>
              <b-card border-variant="info" :header="affiliation.type" align="center">
                <b-card-text> Attivata il  {{ asItalianFormat(affiliation.confirmedAt) }}</b-card-text>
                <b-card-text> Scade il  {{ asItalianFormat(affiliation.enabledUntil) }}</b-card-text>
                <b-card-text> {{ affiliation.cluster.email }}</b-card-text>
              </b-card>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
      <b-col md="9">
        <b-card>
          <template #header>
            <div style="height: 1.5rem">
              <strong>
                <b-icon-person-badge/>&nbsp;Anagrafiche trovate</strong>
              <b-badge v-if="hasActiveCard" variant="success" class="float-right ml-2">Attiva</b-badge>
              <b-badge v-else variant="secondary" class="float-right ml-2">Nessuna tessera attiva</b-badge>
              <b-button @click="showHistory" variant="success" class="float-right" size="sm" pill>
                <b-icon-clock-history/>&nbsp;Mostra Storico
              </b-button>
            </div>
          </template>
          <b-card-body style="padding: 0.5rem">
            <b-form>
              <h6 class="heading-small text-muted mb-4">Dati personali
              </h6>
              <b-form-row>
                <b-col md="6">
                  <b-form-group label-for="full-name-input" description="Nome completo">
                    <b-form-input id="full-name-input" v-model="selectedFullName" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="5">
                  <b-form-group label-for="fiscal-code-input" description="Codice Fiscale">
                    <b-form-input id="fiscal-code-input" v-model="customer.fiscalCode" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label-for="sex-input" description="Sesso">
                    <b-form-input id="sex-input" :value="formatGender(customer.gender)" disabled
                                  class="text-center"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col md="3">
                  <b-form-group label-for="birth-date-input" description="Data di nascita">
                    <b-form-input id="birth-date-input" :value="asItalianFormat(customer.birthDate)" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label-for="birth-place-input" description="Luogo di nascita">
                    <b-form-input id="birth-place-input" v-model="selectedBirthPlace" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <hr>
              <h6 class="heading-small text-muted mb-4">Residenza
              </h6>
              <b-form-row>
                <b-col md="12">
                  <b-form-group label-for="residence-input" description="Indirizzo di residenza">
                    <b-form-input id="residence-input" v-model="selectedResidence" disabled></b-form-input>
                  </b-form-group>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <hr>
              <h6 class="heading-small text-muted mb-4">Dati di contatto
              </h6>
              <b-form-row>
                <b-col md="4">
                  <b-form-group label-for="email-input" description="E-mail">
                    <b-form-input id="email-input" v-model="customer.email" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label-for="mobile-phone-input" description="Numero di cellulare">
                    <b-form-input id="mobile-phone-input" v-model="customer.mobilePhone" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label-for="telephone-input" description="Numero di telefono">
                    <b-form-input id="telephone-input" v-model="customer.telephone" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <hr>
              <h6 class="heading-small text-muted mb-4">Dati famigliari
              </h6>
              <b-form-row>
                <b-col md="1">
                  <b-form-group label-for="family-number-input" description="Numero componenti famigliari">
                    <b-form-input id="family-number-input" v-model="customer.familyNumber" disabled
                                  class="text-center"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="5">
                  <b-form-group label-for="partner-last-name-input" description="Cognome del partner">
                    <b-form-input id="partner-last-name-input" v-model="customer.partnerLastName" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col md="4">
                  <b-form-group label-for="child1-birth-date-input" description="Data di nascita del primogenito">
                    <b-form-input id="child1-birth-date-input" :value="asItalianFormat(customer.firstChildBirthDate)" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label-for="child2-birth-date-input" description="Data di nascita del secondogenito">
                    <b-form-input id="child2-birth-date-input" :value="asItalianFormat(customer.secondChildBirthDate)" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label-for="child3-birth-date-input" description="Data di nascita del terzogenito">
                    <b-form-input id="child3-birth-date-input" :value="asItalianFormat(customer.thirdChildBirthDate)" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import eventBus from '@/EventBus'
import CustomersApi from "@/api/CustomersApi";
import AffiliationsApi from "@/api/AffiliationsApi";
import ShopsApi from "@/api/ShopsApi";

export default {
  name: 'Details',
  props: ['session'],
  provide() {
    return {parentValidator: this.$validator}
  },
  data: () => ({
    barcodesTable: [
      {key: 'index', class: 'text-center small-column'},
      {key: 'barcode', label: 'Tessera', class: 'text-left'},
      {key: 'disabledAt', label: 'Disabilitata il', class: 'text-left'},
    ],
    consensusTable: [
      {key: 'isCheck', class: 'text-center small-column'},
      {key: 'consensus'}
    ],
    shops: null,
    showSpinner: false,
    customer: {},
    barcodes: [],
    activeBarcode: {},
    hasActiveCard: false,
    hideDisableBarcodeButton: false,
    nonDismissedTowns: new Map(),
    affiliation: null
  }),
  mounted() {
    ShopsApi.all()
      .then(shops => this.shops = new Map(shops.map(shop => [shop.code, shop.name])))

    eventBus.$on("customer-selected", (customerPreview) => {
      this.hideDisableBarcodeButton = false
      this.hasActiveCard = customerPreview.hasActiveCard;
      const customerId = customerPreview.customerId;
      CustomersApi.find(customerId)
        .then(res => this.customer = res)
        .catch(() => this.customer = {})

      CustomersApi.findBarcodesBy(customerId)
        .then(barcodes => {
          this.barcodes = barcodes.map(card => ({
            barcode: card.barcode,
            disabledAt: this.formatDateTime(card.disabledAt),
            isDisabled: card.disabledAt != null || false,
            disabledBy: card.disabledBy
          }))
          this.activeBarcode = !barcodes.find(barcode => !barcode.disabledAt) ? null : barcodes.find(barcode => !barcode.disabledAt)
          if(this.activeBarcode != null){
          this.activeBarcode.shopName = this.activeBarcode ? this.shops.get(this.activeBarcode.shopCode) : 'Codice tessera non trovato'}
        })
        .then(() => {
          if(this.activeBarcode != null){
          AffiliationsApi.findBy(this.activeBarcode.barcode)
            .then(res => this.affiliation = res.data)
            .catch(() => this.affiliation = null)
          }
        })
    })
    eventBus.$on("customers-searched", () => this.customer = {})
  },
  computed: {
    selectedConsensus() {
      return [
        {isCheck: this.customer.marketingConsensus, consensus: 'Marketing'},
        {isCheck: this.customer.profilingConsensus, consensus: 'Profilazione'},
        {isCheck: this.customer.cooperativesConsensus, consensus: 'Cooperazione'},
        {isCheck: this.customer.thirdPartyConsensus, consensus: 'Terze Parti'}
      ]
    },
    selectedResidence() {
      const residence = this.customer.residence
      return `${residence.street} n. ${residence.number} ${residence.city} (${residence.province}) ${residence.nation}`
    },
    selectedBirthPlace() {
      const birthPlace = this.customer.birthPlace
      const nation = birthPlace.nation === null ? "ITALIA" : birthPlace.nation
      return (nation === 'ITALIA') ? `${birthPlace.city} (${birthPlace.province}) ${nation}` : `${nation} (${birthPlace.province})`
    },
    selectedFullName() {
      return `${this.customer.lastName} ${this.customer.firstName}`
    },
  },
  methods: {
    isEmpty(object) {
      return Object.keys(object).length === 0
    },
    showHistory() {
      eventBus.$emit('customer-show-history', {})
    },
    disableBarcode(barcode) {
      this.$bvModal.msgBoxConfirm("Sei sicuro di voler disattivare definitivamente la tessera " + barcode + "?", {
        title: 'Disattivazione Irreversibile',
        size: 'sm',
        headerBgVariant: 'dark',
        headerTextVariant: 'light',
        headerCloseVariant: 'light',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Conferma',
        cancelTitle: 'Annulla',
        cancelVariant: 'light',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(agreed => {
          if (agreed) {
            CustomersApi.disableBarcode(this.customer.id, barcode)
              .then(() => {
                this.makeToast('success', "Richiesta disattivazione tessera avvenuta con successo. Da domani questa tessera sarà disattiva")
                this.hideDisableBarcodeButton = true
              })
              .catch(() => { this.makeToast('danger', "Errore nell'eliminazione dell'adesione!!") })
          }
        })
    },
    makeToast(type, message) {
      this.$bvToast.toast(message, {
        title: 'Disattivazione Tessera',
        variant: type,
        toaster: 'b-toaster-top-center',
        solid: true
      })
    },
    formatDateTime: date => date ? moment.utc(date).local().format('llll') : '',
    asItalianFormat: date => date ? moment(date).format('DD/MM/YYYY') : "",
    formatGender: gender => gender.substring(0, 1)
  }
}
</script>

<style>

button.filter-badge {
  border: unset;
  margin-right: 0.5rem;
}

#filters-form-card.card > .card-body {
  padding: unset;
}

#customers-table.table th, #customers-table.table td {
  vertical-align: middle;
}

h6, h5, h4, h3, h2, h1 {
  margin-bottom: unset !important;
  font-weight: bold;
}

#customers-table-card.card > .card-header, #filters-form-card.card > .card-header {
  border-bottom: unset;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}


#customers-table-card.card > .card-body, #customers-table-card.card > .card-body > .card-body {
  padding: 0;
}

#customers-table-card.card > .card-body, #customers-table-card.card > .card-body > .card-body > .table-responsive {
  margin-bottom: unset;
}

#barcodes-table > thead, #consensus-table > thead {
  display: none;
}

div#customers-container > div.row {
  margin-bottom: 1rem
}

.heading-small {
  font-size: .75rem;
  padding-top: .25rem;
  padding-bottom: .25rem;
  letter-spacing: .04em;
  text-transform: uppercase;
  font-weight: bold;
}

.small-column {
  width: 3rem;
}
</style>
